// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q480","importantInfo":"styles_importantInfo__26mV3"};